import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { bannerFormDataAtom } from './BannerFormData.atom';

const isBannerFormValidAtom = atom(false);

export { isBannerFormValidAtom };
